import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  baseUri = environment.dbApi.baseUrl;
  constructor() {}

  buildUrl(
    collectionname: string,
    methodName?: string,
    appendedString?: string
  ): string {
    if (!methodName) {
      methodName = '';
    }
    return !!appendedString
      ? `${this.baseUri}/${collectionname}/${methodName}/${appendedString}`
      : `${this.baseUri}/${collectionname}/${methodName}`;
  }
}
